var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightToLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448 424V88C448 74.75 437.25 64 424 64S400 74.75 400 88V424C400 437.25 410.75 448 424 448S448 437.25 448 424ZM342.625 278.25C348.875 272 352 263.812 352 255.625S348.875 239.25 342.625 233L192.176 97.092C161.309 69.207 112 91.113 112 132.711V175.625H48C21.492 175.625 0 197.115 0 223.625V287.625C0 314.135 21.492 335.625 48 335.625H112V378.912C112 420.543 161.371 442.436 192.227 414.488L342.625 278.25ZM160 287.625H48V223.625H160V134.258L297.367 255.625L160 376.992V287.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightToLine);
export default __webpack_public_path__ + "static/media/right-to-line.b5422792ef7b1e575fb1759386fb6655.svg";
export { ForwardRef as ReactComponent };